import React from "react";
import {Container} from "react-responsive-grid";
import {rhythm} from "../utils/typography";
import SignupButton from './SignupButton';


export default function SignupAdPlanSlide(props) {
  return (
    <div style={{borderTop: '1px solid silver'}}><Container
      style={{
        maxWidth: rhythm(35),
        padding: `${rhythm(2)} ${rhythm(3 / 4)}`,
        textAlign: 'center'
      }}
    >
      <h3 style={{marginTop: 0}}>
        {props.prompt}
      </h3>
      <div style={{marginTop: '50px', marginBottom: '40px'}} className="IndexPage-ButtonBar">
        <SignupButton />

        <a href="/pricing" style={{
          marginLeft: '30px'
        }}>See all our plans</a>
      </div>
    </Container></div>
  )
}


// WEBPACK FOOTER //
// ./src/components/SignupAndPlansSlide.js